import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { BusinessDetailsType } from "types";
import { hasQueryParam } from "utils/helper";

interface IBusinessDetailsReviewProps {
  data: BusinessDetailsType;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
}

type TDataEntries = [keyof BusinessDetailsType, string];

const BusinessDetailsReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
}: IBusinessDetailsReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const wc_flow_with_core_app = hasQueryParam("usecoreapp");

  const questions = wc_flow_with_core_app
    ? (Object.entries(
        sectionsQuestions.businessDetails.questionWithCoreApp
      ) as TDataEntries[])
    : (Object.entries(
        sectionsQuestions.businessDetails.questions
      ) as TDataEntries[]);

  const reQuestions =
    sectionsQuestions.businessDetails.questions.relatedEntities;
  const relatedEntity = data.relatedEntities && data.relatedEntities[0];

  return (
    <EditCard
      title={`${sectionsQuestions.businessDetails.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {questions.map(([key, value]) => {
        let questionText =
          typeof value === "function"
            ? (value as (arg: string) => string)("your company")
            : value;

        if (["companyName", "dba", "ein", "yearFounded"].includes(key)) {
          return (
            <Info
              key={key}
              question={questionText}
              answer={data[key]}
              questionFieldName={key}
            />
          );
        }

        const companyInformation = data?.companyInformation || {};

        return (
          <Info
            key={key}
            question={questionText}
            answer={companyInformation[key]}
            questionFieldName={key}
          />
        );
      })}
      {!!data.relatedEntities &&
        data.relatedEntities.length > 0 &&
        Object.entries(reQuestions).map(([key, value], index) => {
          if (!relatedEntity) return null;

          if (
            [
              "sharesLocation",
              "isDependent",
              "hasOverlappingEmployees",
            ].includes(key) &&
            !relatedEntity.hasW2Employees
          ) {
            return null;
          }

          let questionText =
            typeof value === "function" ? value("your company") : value;
          const relatedKey = key === "entityName" ? "legalName" : key;

          return (
            <div key={`re-q-${index}`}>
              <Info
                key={key}
                question={questionText}
                // @ts-ignore
                answer={relatedEntity[relatedKey]}
                questionFieldName={key}
              />
            </div>
          );
        })}
    </EditCard>
  );
};

export default BusinessDetailsReview;
